const { RA_INVESTMENT_HORIZON_SLIDER_MAX } = require('../constants/RAConstants');
import tools from 'utilities/tools';

const networthValueMap = ['answer4', 'answer3', 'answer2', 'answer1'];
const networthAnswerMap = {
    answer4: 1,
    answer3: 2,
    answer2: 3,
    answer1: 4,
};
const incomeLimitValues = [0, 1500, 2000, 2500, 3000, 3500, 4000, 4500, 5000, 6000, 7000, 8000, 9000, 10000, 11000]; // case 'answer15' (greater strict than 10000) we have to set 11000 by default
const outcomeLimitValues = [
    0, 1000, 1250, 1500, 1750, 2000, 2500, 3000, 3500, 4000, 4500, 5000, 6000, 7000, 8000, 9000, 10000, 11000,
]; // case 'answer18' (greater strict than 10000) we have to set 11000 by default

const horizonSliderAnswerToValue = answer => (answer ? parseInt(answer.replace('answer', ''), 10) - 1 : 0);

const riskSliderAnswerToValue = answer => {
    if (!answer) return 0;

    const number = parseInt(answer.replace('answer', ''), 10);

    return (number - 1) * 5;
};

const networthSliderAnswerToValue = answer => (answer ? networthAnswerMap[answer] : 1);

const networthSliderValueToAnswer = sliderValue => networthValueMap[sliderValue - 1];

const getAmountLimitValues = (answer, values) => {
    const answer1Amount = 500; // case answer1 we have to set a default value
    let amount = 0;

    if (answer) {
        const number = parseInt(answer.replace('answer', ''), 10);

        amount = answer === 'answer1' ? answer1Amount : values[number - 1];
    }

    return amount;
};

const incomeAnswerToValue = answer => getAmountLimitValues(answer, incomeLimitValues);

const outcomeAnswerToValue = answer => getAmountLimitValues(answer, outcomeLimitValues);

const incomeValueToAnswer = incomeValue => {
    let answer;

    if (incomeValue === 10000) {
        answer = 'answer14';
    } else if (incomeValue > 10000) {
        answer = 'answer15';
    } else {
        const index = incomeLimitValues.findIndex(value => incomeValue < value);
        answer = `answer${index}`;
    }

    return answer;
};

const outcomeValueToAnswer = outcomeValue => {
    let answer;

    if (outcomeValue === 10000) {
        answer = 'answer17';
    } else if (outcomeValue > 10000) {
        answer = 'answer18';
    } else {
        const index = outcomeLimitValues.findIndex(value => outcomeValue < value);
        answer = `answer${index}`;
    }

    return answer;
};

const mapDataToAnswers = data => {
    if (!data) return {};
    let answers = {};

    data.forEach(d => {
        switch (d.idQuestion) {
            case '218':
                answers[d.idQuestion] = horizonSliderAnswerToValue(d.idAnswer[0]);
                break;
            case '219':
                answers[d.idQuestion] = riskSliderAnswerToValue(d.idAnswer[0]);
                break;
            case '320':
                answers[d.idQuestion] = incomeAnswerToValue(d.idAnswer[0]);
                break;
            case '321':
                answers[d.idQuestion] = outcomeAnswerToValue(d.idAnswer[0]);
                break;
            case '322':
                answers[d.idQuestion] = networthSliderAnswerToValue(d.idAnswer[0]);
                break;
            case '701':
                answers[d.idQuestion] = parseInt(d.idAnswer[0]);
                break;
            default:
                answers[d.idQuestion] = d.idAnswer[0];
                break;
        }
    });

    return answers;
};

const getStepFromAnswerId = id => {
    switch (id) {
        case '101':
            return { step: { category: 0, step: 0 }, stepIndex: 0 };
        case '102':
            return { step: { category: 0, step: 1 }, stepIndex: 1 };
        case '103':
            return { step: { category: 0, step: 2 }, stepIndex: 2 };
        case '104':
        case '105':
        case '106':
        case '107':
        case '108':
        case '109':
        case '110':
        case '111':
        case '112':
        case '113':
        case '114':
        case '115':
        case '116':
            return { step: { category: 0, step: 3 }, stepIndex: 3 };
        case '217':
            return { step: { category: 1, step: 0 }, stepIndex: 4 };
        case '218':
            return { step: { category: 1, step: 1 }, stepIndex: 5 };
        case '219':
            return { step: { category: 1, step: 2 }, stepIndex: 6 };
        case '320':
        case '321':
            return { step: { category: 2, step: 0 }, stepIndex: 7 };
        case '322':
            return { step: { category: 2, step: 1 }, stepIndex: 8 };
        default:
            return false;
    }
};

const getLastAnswer = ids =>
    getStepFromAnswerId(ids.reduce((acc, val) => (val === '701' ? acc : Math.max(acc, val)), 0).toString());

const getTextClassByLength = text => {
    const medium = 80;
    const short = 36;
    let length = 0;
    let type = '';

    if (text.props) {
        const children = text.props.children;
        length = children[0].length;
        if (children[1].props) {
            length += children[1].props.children[1].length;
        }
    } else {
        length = text.length;
    }

    if (length < medium) {
        type = 'medium';
    } else if (length <= short) {
        type = 'short';
    } else {
        type = 'large';
    }

    return type;
};

const mapInvestmentRowAnswerToValue = answer => {
    let value;

    switch (answer) {
        case 'answer1':
            value = 0;
            break;
        case 'answer2':
            value = 1;
            break;
        case 'answer3':
            value = 2;
            break;
        default:
            value = 0;
            break;
    }

    return value;
};

const mapInvestmentRowValueToAnswer = answer => `answer${answer - 104}`;

const riskSliderValueToAnswer = sliderValue => `answer${sliderValue / 5 + 1}`;

const horizonSliderValueToAnswer = sliderValue => {
    let answer;
    if (sliderValue >= RA_INVESTMENT_HORIZON_SLIDER_MAX) {
        answer = 'answer27';
    } else {
        answer = `answer${sliderValue + 1}`;
    }

    return answer;
};

const wizzardStatus = ({ key, index, isExitTest }) => {
    let retakeToStep =
        key === 0 && index === 3
            ? 1
            : (key === 1 && index === 3) || (key === 1 && index === 2)
            ? 2
            : isExitTest
            ? key
            : key;
    let retakeToSubStep =
        (key === 0 && index === 3) || (key === 1 && index === 3) || (key === 1 && index === 2)
            ? 0
            : isExitTest
            ? index
            : index + 1;
    return { retakeToStep, retakeToSubStep };
};

const getCurrentStep = (step, substep) => {
    let currentStep = 0;

    if (step === 0) {
        currentStep = substep;
    } else if (step === 1) {
        currentStep = substep + 4;
    } else {
        currentStep = substep + 7;
    }

    return currentStep;
};

const buildLoginPayload = () => {
    const uuid = tools.initFingerprint();
    const osVersion = tools.getOsVersion();
    return {
        osVersion,
        uuid,
        webVersion: window.navigator.userAgent,
    };
};

export default {
    getLastAnswer,
    getTextClassByLength,
    horizonSliderValueToAnswer,
    incomeValueToAnswer,
    mapDataToAnswers,
    mapInvestmentRowAnswerToValue,
    mapInvestmentRowValueToAnswer,
    networthSliderValueToAnswer,
    outcomeValueToAnswer,
    riskSliderValueToAnswer,
    wizzardStatus,
    getCurrentStep,
    buildLoginPayload,
};
